import { usePricedServicesData } from './usePricedServicesData'
import { useContactData } from './useContactData'
import { useAboutData } from './useAboutData'
import { useGeneralData } from './useGeneralData'
import { useTestimonialsData } from './useTestimonialsData'

export { usePricedServicesData, useContactData, useAboutData, useGeneralData, useTestimonialsData }
